import { Card, Button, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../analytics";
import { tagProps } from "./utils";

const { Meta } = Card;

export default function DisplayCard({ item }) {
  const navigate = useNavigate();
  const status = (item.status || "").toLowerCase();
  const tag = tagProps[status] || { color: "default", text: item.status || "" };

  const cardStyle =
    status === "sold out" || status === "not available"
      ? { filter: "grayscale(1) opacity(0.7)" }
      : {};

  const handleMore = () => {
    const category = item.SKU.split("-")[0].toLowerCase();

    trackEvent(`view_${category}_product`, {
      sku: item.SKU,
    });
    if (item.SKU.startsWith("SCUBA-")) {
      navigate(`/scuba/${encodeURIComponent(item.SKU)}`);
    } else if (item.SKU.startsWith("SKY-")) {
      navigate(`/skydive/${encodeURIComponent(item.SKU)}`);
    }
    else if (item.SKU.startsWith("TRIP-")) {
      navigate(`/trips/${encodeURIComponent(item.SKU)}`);
    }
  };

  const coverImg = item.photos && item.photos.length ? item.photos[0] : "";

  return (
    <Card
      onClick={handleMore}
      hoverable
      style={{
        margin: "12px",
        ...cardStyle,
        position: "relative",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 6px 20px rgba(0,0,0,0.19)",
      }}
      cover={
        coverImg ? (
          <img
            alt={item.title}
            src={coverImg}
            style={{ height: 180, objectFit: "cover" }}
          />
        ) : null
      }
    >

      <Meta size="small" title={item.title} description={item.SKU} />
      <div style={{ marginTop: "8px"}}>
        <Tag key={tag.color} variant="filled" color={tag.color}>
          {tag.text}
        </Tag>
      </div>

      <div
        style={{
          marginTop: 12,
          display: "flex",
          justifyContent: "right",
          alignItems: "center",
        }}
      >
        <Button type="default" size="middle" onClick={handleMore}>
          More details
        </Button>
      </div>
    </Card>
  );
}
